import * as React from "react"
import { useToast } from "~/ui/use-toast"
import { Copy } from "lucide-react"
import { cn } from "~/common/cn"

export interface CopyButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string
  description: string
  showCopyText?: boolean
}

const CopyButton = React.forwardRef<HTMLButtonElement, CopyButtonProps>(
  ({ description, text, className, showCopyText }, ref) => {
    const { toast } = useToast()

    const copyToClipboard = async () => {
      try {
        await navigator.clipboard.writeText(text)
        toast({
          description: `${description} copied`,
        })
      } catch (err) {
        console.error("Failed to copy text: ", err)
        toast({
          title: "Failed to copy",
          description: "Please try again",
          variant: "destructive",
        })
      }
    }

    return (
      <button
        ref={ref}
        onClick={(e) => {
          e.preventDefault()
          copyToClipboard()
        }}
        className={cn("ml-4 text-gray-400 transition-colors hover:text-white", className)}
        title="Copy to clipboard"
      >
        <div className="flex justify-center gap-1">
          <Copy className="h-5 w-5 shrink" />
          {showCopyText && <span className="text-xs font-normal">Copy</span>}
        </div>
      </button>
    )
  }
)

CopyButton.displayName = "CopyButton"
export { CopyButton }
